<template>
  <button :id="id" v-bind:disabled="disabled" @click="$emit('click') " class="btn" v-bind:style="btnStyle">
    <slot v-if="!loadingState" ></slot>
    <div v-if="loadingState" class="spinner spinner--1"></div>
  </button>
</template>

<script>
import ColorUtils from "../utils/ColorUtils";

export default {
  components: {},
  props: {
    disabled : Boolean, // Refactor THis Later
    loadingState : {
      type : Boolean,
      default : false
    },
  },
  computed: {
    MainUISettings() {
      return this.$store.getters["GET_MAIN_UI"];
    },

    btnStyle() {
      var colorUtils = new ColorUtils();

      var btnTextColor = this.$store.getters["GET_MAIN_UI"].button_text_color;
      var btnBackgroundColor = this.$store.getters["GET_MAIN_UI"].button_color;
      var btnBackgroundLighter = colorUtils.adjust(btnBackgroundColor, 10);
      var btnBackgroundDarker = colorUtils.adjust(btnBackgroundColor, -10);

      return {
        "--button-color": btnTextColor,
        "--button-background-color": btnBackgroundColor,

        "--button-color--hover": btnTextColor,
        "--button-background-color--hover": btnBackgroundLighter,
        "--button-background-color--active": btnBackgroundDarker
      };
    },
    id() {
      return this.$options._scopeId
    }
  }
};
</script>


<style lang="scss" scoped>

button.btn {
  color: var(--button-color);
  background-color: var(--button-background-color);
}

button.btn:hover {
  filter: brightness(120%);
  background-color: var(--button-background-color--hover);
}
button.btn:active {
  filter: brightness(90%);
  background-color: var(--button-background-color--active);
}

.spinner {
	height: 20px;
	width: 20px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.spinner--1 {
	border-top: 2px solid #fff;
	animation: spinner1 600ms linear infinite;
}
@keyframes spinner1 {
	to {
		transform: rotate(360deg);
	}
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  transform: scale(0.5);
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
  transform: scale(0.5);
}
</style>